import {env} from "../env/env";
import {DesignView} from "../components/dsa/EditScreenContentModal";
import {DesignDto} from "../generated/dashboard-client";

export function getLocationDesignsPerPage(data: DesignDto[]) {
  const bits = [] as DesignView[];
  data.forEach(it => {
    it.pageCount = it.pageCount ?? 1;

    for (let page = 1; page <= it.pageCount; page++) {
      bits.push({
        id: it.id ?? "",
        size: it.size ?? "",
        name: it.name ?? "",
        page,
        thumbnail: `${env.rendererPath}/design/thumbnail/${it.id}?height=${env.rendererImageHeight}&update=${(new Date((it.updatedDate!)).getTime())}&page=${page}`,
        selected: false,
        visible: true,
        width: it.width ?? "",
        height: it.height ?? ""
      });
    }
  });
  return bits;
}
